import React, {Component} from 'react';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import Errors from '../common/Errors';
import {Redirect} from 'react-router-dom';
import * as AppConstant from "../common/AppConstant";
import SimpleReactValidator from 'simple-react-validator';
import {Link} from 'react-router-dom';
import * as Util from '../common/Util';
import RequiredAstrisk from '../common/RequiredAstrisk';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

class PaymentProcessorConfiguration extends Component{
    constructor(props){
        super(props);
        this.state = {
            paymentProcessorConfig: {
                paymentProcessor: '',
                enablePayments: true,
                accountId: '',
                lastKeyRotation: null,
                processorUserid: '',
                processorPassword: '',
                primaryUrl: '',
                pin: '',
                isSettlementRequired: false,
                isBatchMode: false,
                isTokenizationRequired: false,
                useForDisbursement: false,
                isAvsRequired: false,
                isAchEnabled: false,
                isCreditCardEnabled: false,
                isCODEnabled: false,
                isCvvRequired: false,
                key1: '',
                value1: '',
                key2: '',
                value2: '',
                key3: '',
                value3: '',
                key4: '',
                value4: '',
                key5: '',
                value5: ''

            },
            loggedInUser:{},
            paymentProcessors: {},
            disabledButton: false,
            redirectToDashBoard: false,
            redirectToErrorPage: false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            errorMessage: '',
            showDiv: false,
            showLoader: false,
            showUserName: false,
            showAPILoginId: false,
            showApplicationLogin: false,
            showProfileId: false,
            showMerchantId: false,
            showPassword: false,
            showTransactionKey: false,
            showConnectionTicket: false,
            showProfileKey: false,
            showSecretKey: false,
            showLiveSecretKey: false,
            showAccountIdLbl: false,
            showValidationMode: false,
            showPin: false,
            showAccountId: false,
            showProcessorUserId: false,
            showLastKeyRotation: true,
            showLastKeyRotationLbl: true,
            showMerchantTokenLbl: false,
            showApiSecret: false
        }
        this.fetchPaymentProcessorConf = this.fetchPaymentProcessorConf.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.changeUrls = this.changeUrls.bind(this);
        this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
        this.showHideFields = this.showHideFields.bind(this);
        this.handleShowAdvanceOptions = this.handleShowAdvanceOptions.bind(this);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.validator = new SimpleReactValidator ({
            autoForceUpdate: this,
            element: false
        });
    }

    componentDidMount(){
        if(this.props.params && this.props.params.msg) {
            const {apiStatus} = this.state;
            apiStatus.isError = true;
            apiStatus.message = this.props.params.msg;
            this.setState({apiStatus: apiStatus});
        }
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchPaymentProcessorConf();
                            const {paymentProcessorConfig} = _this.state;
                            _this.showHideFields(paymentProcessorConfig.paymentProcessor)
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    fetchPaymentProcessorConf() {
        this.setState({showLoader: true});
        fetch(this.props.api +'/processorConfig', {
            method: 'GET',
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        }).then(response => response.json())
            .then(json => {
                if (json && json.isError === false) {
                    const paymentProcessorConfig = json.paymentProcessorConfig;
                    const bluConf = json.bluConfiguration;
                    if(paymentProcessorConfig && paymentProcessorConfig.lastKeyRotation){
                        paymentProcessorConfig.lastKeyRotation = moment(paymentProcessorConfig.lastKeyRotation).format("MM/DD/YYYY")
                    }
                    this.showHideFields(paymentProcessorConfig.paymentProcessor);
                    if(bluConf){
                        paymentProcessorConfig["enablePayments"] = (bluConf.enablePayments === null || bluConf.enablePayments === undefined) ? false : bluConf.enablePayments
                    }
                    this.setState({paymentProcessorConfig: paymentProcessorConfig, showLoader: false, paymentProcessors: json.paymentProcessors});
                } else {
                    this.setState({showLoader: false, paymentProcessors: json.paymentProcessors});
                    if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                }
            }).catch(error => {
            console.log(error);
            this.setState({showLoader: false});

        });

    }

    handleChange(event){
        const {paymentProcessorConfig} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        paymentProcessorConfig[name]=value;
        this.setState({paymentProcessorConfig:paymentProcessorConfig});
        if(name === "paymentProcessor"){
            this.showHideFields(value)
            paymentProcessorConfig["primaryUrl"]='';
            this.changeUrls('Production')
        }
    }

    showHideFields(paymentProcessor){
        if(paymentProcessor === "Orbital Payment V1"){
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: true})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor === "PayConex"){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showLastKeyRotation: false})
            this.setState({showLastKeyRotationLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: true})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor === "First Data Global Gateway V1"){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor === "Lucy V1"){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='Authorize.NET V1') {
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: true})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: true})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor ==='Authorize.Net CIM V1') {
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: true})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: true})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: true})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='Intuit/Quickbooks Merchant Services V1') {
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: true})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: true})
            this.setState({showConnectionTicket: true})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='Paypal Payflow Pro V1') {
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor ==='Paypal Website Pro V1') {
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor ==='Paysimple Processor V1') {
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: true})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='MeS Payment Gateway V1'){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: true})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: true})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }  else if(paymentProcessor ==='Green by Phone'){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='Zaakpay' || paymentProcessor ==='Easypay' || paymentProcessor ==='CCAvenue' || paymentProcessor ==='Citruspay'
            || paymentProcessor ==='Billdesk' || paymentProcessor ==='EBS' || paymentProcessor ==='PayuBiz' || paymentProcessor === 'HDFC' || paymentProcessor ==='PayU'
            || paymentProcessor ==='XpressPay'){
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: true})
            this.setState({showSecretKey: true})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }else if(paymentProcessor ==='Willow Systems'){
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: false})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: true})
            this.setState({showSecretKey: true})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        } else if(paymentProcessor ==='Stripe'){
            this.setState({showAccountId: false})
            this.setState({showAccountIdLbl: false})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: true})
            this.setState({showUserName: false})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: false})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: true})
        } else if(paymentProcessor ==='Payeezy'){
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: false})
            this.setState({showMerchantTokenLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showPin: false})
            this.setState({showUserName: true})
            this.setState({showPassword: false})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: true})
            this.setState({showLiveSecretKey: false})
        }  else {
            this.setState({showAccountId: true})
            this.setState({showAccountIdLbl: true})
            this.setState({showValidationMode: false})
            this.setState({showMerchantTokenLbl: false})
            this.setState({showPin: true})
            this.setState({showUserName: true})
            this.setState({showPassword: true})
            this.setState({showAPILoginId: false})
            this.setState({showProfileId: false})
            this.setState({showTransactionKey: false})
            this.setState({showProcessorUserId: true})
            this.setState({showApplicationLogin: false})
            this.setState({showConnectionTicket: false})
            this.setState({showProfileKey: false})
            this.setState({showMerchantId: false})
            this.setState({showSecretKey: false})
            this.setState({showApiSecret: false})
            this.setState({showLiveSecretKey: false})
        }
       /* if(paymentProcessor ==='Authorize.Net CIM V1') {
            <!--  	document.processorConfigurationForm.isTokenizationRequired.checked = true;   -->                     <!--changes Done Here -->
        }
        else {
            <!--  	document.processorConfigurationForm.isTokenizationRequired.checked = false;    -->
        }

        if(paymentProcessor ==='Intuit') {
            jQuery("#connectToQBOnlinePayment").show()
        }
        if(paymentProcessor !='Intuit') {
            jQuery("#connectToQBOnlinePayment").hide()
        }*/
    }

    handleSubmit(event) {
        event.preventDefault();
        const {apiStatus} = this.state;
        if (this.validator.allValid()) {
            this.setState({showLoader: true});
            fetch(this.props.api + "/processorConfig", {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.paymentProcessorConfig),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
				console.log(json)
                if (json && json.isError === false) {
                    Util.successResponse(apiStatus, json)
					this.setState({
                    disabledButton: false,
                    apiStatus: apiStatus,
                    showLoader: false,
                    redirectToDashBoard: (apiStatus.isError === false ? true : false)
                    });
                } else {
                    Util.errorResponse(apiStatus, json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                    this.setState({
                        disabledButton: false,
                        apiStatus: apiStatus,
                        showLoader: false
                    });
                }
            })
            .catch(error => {
                Util.errorCatchResponse(apiStatus, error);
                this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    changeUrls(event){
        let productionOrStaging = event
        const {paymentProcessorConfig} = this.state;
        let paymentProcessor = paymentProcessorConfig.paymentProcessor;
        console.log("paymentProcessor === ", paymentProcessor)
        console.log("productionOrStaging === ", productionOrStaging)
        if(productionOrStaging === "Production"){
            if(paymentProcessor === 'Orbital Payment V1') {
                paymentProcessorConfig["primaryUrl"]='https://orbitalvar1.paymentech.net';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor === 'PayConex') {
                paymentProcessorConfig["primaryUrl"]='https://secure.payconex.net/api/qsapi/3.8/';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='First Data Global Gateway V1') {
                paymentProcessorConfig["primaryUrl"]='https://ws.firstdataglobalgateway.com/fdggwsapi/services';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='Lucy V1') {
                paymentProcessorConfig["primaryUrl"]='https://payments.cynergydata.com/SmartPayments/transact2.asmx?op=ProcessCreditCard';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='Litle V1') {
                paymentProcessorConfig["primaryUrl"]='https://litle.com/vap/communicator/online';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='Authorize.NET V1') {
                paymentProcessorConfig["primaryUrl"]='PRODUCTION';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='Authorize.Net CIM V1') {
                paymentProcessorConfig["primaryUrl"]='https://api.authorize.net/xml/v1/request.api';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

                let validationMode = paymentProcessorConfig.accountId;
                if (validationMode) {
                    paymentProcessorConfig["accountId"] = validationMode;
                    this.setState({paymentProcessorConfig: paymentProcessorConfig})
                } else {
                    paymentProcessorConfig["accountId"] = 'liveMode';
                    this.setState({paymentProcessorConfig: paymentProcessorConfig})
                }
            }
            else if(paymentProcessor ==='Intuit/Quickbooks Merchant Services V1') {
                paymentProcessorConfig["primaryUrl"]='https://merchantaccount.quickbooks.com/j/AppGateway';
                this.setState({paymentProcessorConfig:paymentProcessorConfig})

            }
            else if(paymentProcessor ==='Paypal Payflow Pro V1') {
                paymentProcessorConfig["primaryUrl"]='payflowpro.paypal.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Paypal Website Pro V1') {
                paymentProcessorConfig["primaryUrl"]='live';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Paysimple Processor V1') {
                paymentProcessorConfig["primaryUrl"]='https://sandbox.paysimple.com/Gateway.asmx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='MeS Payment Gateway V1') {
                paymentProcessorConfig["primaryUrl"]='https://cert.merchante-solutions.com/mes-api/tridentApi';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Zaakpay') {
                paymentProcessorConfig["primaryUrl"]='https://api.zaakpay.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Easypay') {
                paymentProcessorConfig["primaryUrl"]='https://epay.federalbank.co.in/FedPayments/Payment.aspx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='CCAvenue') {
                paymentProcessorConfig["primaryUrl"]='https://secure.ccavenue.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Green by Phone') {
                paymentProcessorConfig["primaryUrl"]='https://www.greenbyphone.com/eCheck.asmx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Willow Systems') {
                paymentProcessorConfig["primaryUrl"]='https://secure.willow-systems.com/direct/transactioncapture.aspx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Citruspay') {
                paymentProcessorConfig["primaryUrl"]='https://sandbox.citruspay.com/cb9shb7t7z';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Billdesk') {
                paymentProcessorConfig["primaryUrl"]='https://pgi.billdesk.com/pgidsk/PGIMerchantPayment';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='EBS' || paymentProcessor ==='XpressPay') {
                paymentProcessorConfig["value1"] = 'LIVE';
                paymentProcessorConfig["key2"] = 'API_URL';
                paymentProcessorConfig["value2"] = 'https://api.secure.ebs.in/api/status';
                paymentProcessorConfig["primaryUrl"]='https://secure.ebs.in/pg/ma/payment/request';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='HDFC') {
                paymentProcessorConfig["primaryUrl"]='https://www.tpsl-india.in/PaymentGateway/services/TransactionDetailsNew';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='PayU') {
                paymentProcessorConfig["primaryUrl"]='https://secure.payu.in/_payment';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Stripe') {
                paymentProcessorConfig["primaryUrl"]='https://api.stripe.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Payeezy') {
                paymentProcessorConfig["primaryUrl"]='https://api.payeezy.com/v1';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else {
                paymentProcessorConfig["primaryUrl"]='PRODUCTION';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }

        }
        /*Staging Url*/
        else if(productionOrStaging === "Staging"){
            if(paymentProcessor === 'Orbital Payment V1') {
                paymentProcessorConfig["primaryUrl"]='https://orbitalvar1.paymentech.net';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            if(paymentProcessor === 'PayConex') {
                paymentProcessorConfig["primaryUrl"]='https://cert.payconex.net/api/qsapi/3.8/';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='First Data Global Gateway V1') {
                paymentProcessorConfig["primaryUrl"]='https://ws.merchanttest.firstdataglobalgateway.com:443/fdggwsapi/services';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Lucy V1') {
                paymentProcessorConfig["primaryUrl"]='https://cpgtest.cynergydata.com/SmartPayments/transact2.asmx/ProcessCreditCard';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Litle V1') {
                paymentProcessorConfig["primaryUrl"]='https://cert.litle.com/vap/communicator/online';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Authorize.NET V1') {
                paymentProcessorConfig["primaryUrl"]='SANDBOX';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Authorize.Net CIM V1') {
                paymentProcessorConfig["primaryUrl"]='https://apitest.authorize.net/xml/v1/request.api';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
                let validationMode = paymentProcessorConfig.accountId;
                if (validationMode) {
                    paymentProcessorConfig["accountId"] = validationMode;
                    this.setState({paymentProcessorConfig: paymentProcessorConfig})
                } else {
                    paymentProcessorConfig["accountId"] = 'testMode';
                    this.setState({paymentProcessorConfig: paymentProcessorConfig})
                }
            }
            else if(paymentProcessor ==='Intuit/Quickbooks Merchant Services V1') {
                paymentProcessorConfig["primaryUrl"]='https://merchantaccount.ptc.quickbooks.com/j/AppGateway';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Paypal Payflow Pro V1') {
                paymentProcessorConfig["primaryUrl"]='pilot-payflowpro.paypal.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Paypal Website Pro V1') {
                paymentProcessorConfig["primaryUrl"]='sandbox';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='Paysimple Processor V1') {
                paymentProcessorConfig["primaryUrl"]='https://sandbox.paysimple.com/Gateway.asmx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }
            else if(paymentProcessor ==='MeS Payment Gateway V1') {
                paymentProcessorConfig["primaryUrl"]='https://cert.merchante-solutions.com/mes-api/tridentApi';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Zaakpay') {
                paymentProcessorConfig["primaryUrl"]='https://api.zaakpay.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Easypay') {
                paymentProcessorConfig["primaryUrl"]='https://epay.federalbank.co.in/FedPayments/EasyPayment.aspx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='CCAvenue') {
                paymentProcessorConfig["primaryUrl"]='https://test.ccavenue.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Green by Phone') {
                paymentProcessorConfig["primaryUrl"]='https://www.greenbyphone.com/eCheck.asmx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Willow Systems') {
                paymentProcessorConfig["primaryUrl"]='https://secure.willow-systems.com/direct/transactioncapture.aspx';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Citruspay') {
                paymentProcessorConfig["primaryUrl"]='https://sandbox.citruspay.com/cb9shb7t7z';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Billdesk') {
                paymentProcessorConfig["primaryUrl"]='https://pgi.billdesk.com/pgidsk/PGIMerchantPayment';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='EBS' || paymentProcessor ==='XpressPay') {
                paymentProcessorConfig["value1"] = 'TEST';
                paymentProcessorConfig["key2"] = 'API_URL';
                paymentProcessorConfig["value2"] = 'https://api.secure.ebs.in/api/status';
                paymentProcessorConfig["primaryUrl"]='https://secure.ebs.in/pg/ma/payment/request';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }

            else if(paymentProcessor ==='HDFC') {
                paymentProcessorConfig["primaryUrl"]='https://www.tekprocess.co.in/PaymentGateway/services/TransactionDetailsNew';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='PayU') {
                paymentProcessorConfig["primaryUrl"]='https://test.payu.in/_payment';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Stripe') {
                paymentProcessorConfig["primaryUrl"]='https://api.stripe.com';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else if(paymentProcessor ==='Payeezy') {
                paymentProcessorConfig["primaryUrl"]='https://api-cert.payeezy.com/v1';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});
            }
            else {
                paymentProcessorConfig["primaryUrl"]='SANDBOX';
                this.setState({paymentProcessorConfig:paymentProcessorConfig});

            }

        }
    }

    handleChangeDatePicker(name,date) {
        const {paymentProcessorConfig} = this.state;
        paymentProcessorConfig[name] = moment(date).format("MM/DD/YYYY")
        this.setState({paymentProcessorConfig: paymentProcessorConfig});
    }

    checkBoxChange(value, name){
        if (value === true) {
            const {paymentProcessorConfig} = this.state;
            paymentProcessorConfig[name] = false;
            this.setState({paymentProcessorConfig: paymentProcessorConfig});
        } else {
            const {paymentProcessorConfig} = this.state;
            paymentProcessorConfig[name] = true;
            this.setState({paymentProcessorConfig: paymentProcessorConfig});
        }
    }

    handleShowAdvanceOptions(){
        this.setState({showDiv: !this.state.showDiv})
    }


    render() {
        let _this = this;
        const paymentProcessors = this.state.paymentProcessors && Object.keys(this.state.paymentProcessors).map(function(key){
            return  <option key={key} value={key}>{_this.state.paymentProcessors[key]}</option>
        })
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to = {'/msg/'+this.state.apiStatus.message}/>):null
                }
                   <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('paymentProcessorConfiguration.label.header')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                            <form onSubmit={this.handleSubmit} className="form-horizontal">
                                <div className="col-md-12">
                                    <div className="col-md-8">
                                        <div className="form-group row">
                                            <label
                                                className="col-lg-6 control-label">{_this.props.msg('paymentProcessorConfiguration.label.processor')}<RequiredAstrisk/></label>
                                            <div className="col-lg-6">
                                                <select type="text" className="form-control" id="paymentProcessor" title={_this.props.msg('paymentProcessorConfiguration.tooltip.processorName')}
                                                        name="paymentProcessor" onChange={this.handleChange}
                                                        value={this.state.paymentProcessorConfig.paymentProcessor?this.state.paymentProcessorConfig.paymentProcessor:''}>
                                                    <option value="">-Select-</option>
                                                    {paymentProcessors}
                                                </select>
                                                <div style={{color: "red"}}>
                                                    {this.validator.message('paymentProcessor', this.state.paymentProcessorConfig.paymentProcessor, 'required')}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-lg-6 control-label">{_this.props.msg('bluConfig.label.enableProcessPayment')}</label>

                                            <div className="col-lg-6">
                                                <div className="onoffswitch">
                                                    <input type="checkbox" id="enablePayments" name="enablePayments"  className="onoffswitch-checkbox"
                                                        checked={this.state.paymentProcessorConfig.enablePayments}
                                                        onChange={(e) => this.checkBoxChange(this.state.paymentProcessorConfig.enablePayments, 'enablePayments')}/>
                                                    <label className="onoffswitch-label" htmlFor="enablePayments">
                                                        <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                        <span className="onoffswitch-switch"></span>
                                                    </label>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label id ="accountIdLbl" className="col-lg-6 control-label" style={{display:this.state.showAccountIdLbl===false?'none':'block'}}>{_this.props.msg('paymentProcessorConfiguration.label.accountId')}</label>
                                            <label id="validationMode" className="col-lg-6 control-label" style={{display:this.state.showValidationMode===false?'none':'block'}}>Validation Mode</label>
                                            <label id="merchantToken" className="col-lg-6 control-label" style={{display:this.state.showMerchantTokenLbl===false?'none':'block'}}>Merchant Token</label>

                                            <div className="col-lg-6" style={{display:this.state.showAccountId===false?'none':'block'}}>
                                                <input type="text" className="form-control" id="accountId" title={_this.props.msg('paymentProcessorConfiguration.tooltip.accountId')}
                                                       onChange={this.handleChange}
                                                       name="accountId"
                                                       value={this.state.paymentProcessorConfig.accountId?this.state.paymentProcessorConfig.accountId:''} maxLength="255" minLength="3"/>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label id = "processorUserid" className="col-lg-6 control-label" style={{display:this.state.showUserName===false?'none':'block'}}>{_this.props.msg('paymentProcessorConfiguration.label.processorUserId')}</label>
                                            <label id = "apiLoginId" className="col-lg-6 control-label" style={{display:this.state.showAPILoginId===false?'none':'block'}}>ApI Login Id</label>
                                            <label id = "applicationLogin" className="col-lg-6 control-label" style={{display:this.state.showApplicationLogin===false?'none':'block'}}>Application Login</label>
                                            <label id = "profileId" className="col-lg-6 control-label" style={{display:this.state.showProfileId===false?'none':'block'}}>Profile Id</label>
                                            <label id = "merchantId" className="col-lg-6 control-label" style={{display:this.state.showMerchantId===false?'none':'block'}}>Merchant Identifier</label>

                                            <div className="col-lg-6" style={{display:this.state.showProcessorUserId===false?'none':'block'}}>
                                                <input type="text" className="form-control" id="processorUserid" title={_this.props.msg('paymentProcessorConfiguration.tooltip.processorUserid')}
                                                       onChange={this.handleChange}
                                                       name="processorUserid" autoComplete="new-username"
                                                       value={this.state.paymentProcessorConfig.processorUserid ? this.state.paymentProcessorConfig.processorUserid : ''}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label id="processorPassword" className="col-lg-6 control-label" style={{display:this.state.showPassword===false?'none':'block'}}>{_this.props.msg('paymentProcessorConfiguration.label.processorPassword')}</label>
                                            <label id="transactionKey" className="col-lg-6 control-label" style={{display:this.state.showTransactionKey===false?'none':'block'}}>Transaction Key</label>
                                            <label id="connectionTicket" className="col-lg-6 control-label" style={{display:this.state.showConnectionTicket===false?'none':'block'}}>Connection Ticket</label>
                                            <label id="profileKey" className="col-lg-6 control-label" style={{display:this.state.showProfileKey===false?'none':'block'}}>Profile Key</label>
                                            <label id="secretKey" className="col-lg-6 control-label" style={{display:this.state.showSecretKey===false?'none':'block'}}>Secret Key</label>
                                            <label id="liveSecretKeyId" className="col-lg-6 control-label" style={{display:this.state.showLiveSecretKey===false?'none':'block'}}>Live Secret Key</label>
                                            <label id="apiSecret" className="col-lg-6 control-label" style={{display:this.state.showApiSecret===false?'none':'block'}}>API Secret</label>
                                            <div className="col-lg-6">
                                                <input type="password" className="form-control" id="processorPassword" title={_this.props.msg('paymentProcessorConfiguration.tooltip.processorPassword')}
                                                       onChange={this.handleChange}
                                                       name="processorPassword" autoComplete="new-password"
                                                       value={this.state.paymentProcessorConfig.processorPassword ? this.state.paymentProcessorConfig.processorPassword : ''}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-lg-10 control-label"> <a style={{textDecoration:'underline'}} onClick={this.handleShowAdvanceOptions}>Show / Hide Advanced Options</a></label>
                                        </div>
                                        <div id="paymentProcessorAdvanceConfig" style={{display:this.state.showDiv===false?'none':'block'}}>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-6 control-label">{_this.props.msg('paymentProcessorConfiguration.label.primaryUrl')}</label>

                                                <div className="col-lg-6">
                                            <textarea type="text" className="form-control" id="primaryUrl" title={_this.props.msg('paymentProcessorConfiguration.tooltip.primaryUrl')}
                                                      onChange={this.handleChange}
                                                      name="primaryUrl"
                                                      value={this.state.paymentProcessorConfig.primaryUrl ? this.state.paymentProcessorConfig.primaryUrl : ''}
                                            />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={{marginLeft: "108px"}}>
                                                <label className="col-lg-10 control-label">
                                                    <a style={{textDecoration:"underline", marginLeft: "220px"}} onClick={(e)=>_this.changeUrls("Production")}>Use Default Production URL</a>
                                                </label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-10 control-label">
                                                    <a style={{textDecoration:"underline", marginLeft: "220px"}} onClick={(e)=>_this.changeUrls("Staging")}>Use Default Staging URL</a>
                                                </label>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-6 control-label">{_this.props.msg('paymentProcessorConfiguration.label.isTokenizationRequired')}</label>

                                                <div className="col-lg-1 m-t-xs">

                                                    <div className="onoffswitch">
                                                        <input type="checkbox"
                                                               id="isTokenizationRequired"
                                                               name="isTokenizationRequired" className="onoffswitch-checkbox"
                                                               checked={_this.state.paymentProcessorConfig.isTokenizationRequired}
                                                               onChange={(e) => _this.checkBoxChange(_this.state.paymentProcessorConfig.isTokenizationRequired, 'isTokenizationRequired')}
                                                        />
                                                        <label className="onoffswitch-label" htmlFor="isTokenizationRequired">
                                                            <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                            <span className="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-6 control-label">{_this.props.msg('paymentProcessorConfiguration.label.isAchEnabled')}</label>

                                                <div className="col-lg-1 m-t-xs">
                                                    <div className="onoffswitch">
                                                        <input type="checkbox"  id="isAchEnabled"
                                                               name="isAchEnabled" className="onoffswitch-checkbox"
                                                               checked={_this.state.paymentProcessorConfig.isAchEnabled}
                                                               onChange={(e) => _this.checkBoxChange(_this.state.paymentProcessorConfig.isAchEnabled, 'isAchEnabled')}
                                                        />
                                                        <label className="onoffswitch-label" htmlFor="isAchEnabled">
                                                            <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                            <span className="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-6 control-label">{_this.props.msg('paymentProcessorConfiguration.label.isCreditCardEnabled')}</label>

                                                <div className="col-lg-1 m-t-xs">
                                                    <div className="onoffswitch">
                                                        <input type="checkbox"
                                                               id="isCreditCardEnabled"
                                                               name="isCreditCardEnabled" className="onoffswitch-checkbox"
                                                               checked={_this.state.paymentProcessorConfig.isCreditCardEnabled}
                                                               onChange={(e) => _this.checkBoxChange(_this.state.paymentProcessorConfig.isCreditCardEnabled, 'isCreditCardEnabled')}
                                                        />
                                                        <label className="onoffswitch-label" htmlFor="isCreditCardEnabled">
                                                            <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                            <span className="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*Custom settings*/}
                                            <hr/>
                                            <div style={{float:"right"}}>
                                            <label style={{fontWeight:'bold'}}>{_this.props.msg('paymentProcessorConfiguration.label.cutomSettings')}</label>
                                            <div className="form-group row">
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="key1"
                                                           onChange={this.handleChange}
                                                           name="key1"
                                                           value={this.state.paymentProcessorConfig.key1 ? this.state.paymentProcessorConfig.key1 : ''}
                                                    />
                                                </div>
                                                <span className="col-lg-1 m-t-sm" style={{fontWeight:'bold', marginRight: '-20px'}}>=</span>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="value1"
                                                           onChange={this.handleChange}
                                                           name="value1"
                                                           value={this.state.paymentProcessorConfig.value1 ? this.state.paymentProcessorConfig.value1 : ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="key2"
                                                           onChange={this.handleChange}
                                                           name="key2"
                                                           value={this.state.paymentProcessorConfig.key2 ? this.state.paymentProcessorConfig.key2 : ''}
                                                    />
                                                </div>
                                                <span className="col-lg-1 m-t-sm" style={{fontWeight:'bold', marginRight: '-20px'}}>=</span>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="value2"
                                                           onChange={this.handleChange}
                                                           name="value2"
                                                           value={this.state.paymentProcessorConfig.value2 ? this.state.paymentProcessorConfig.value2 : ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="key3"
                                                           onChange={this.handleChange}
                                                           name="key3"
                                                           value={this.state.paymentProcessorConfig.key3 ? this.state.paymentProcessorConfig.key3 : ''}
                                                    />
                                                </div>
                                                <span className="col-lg-1 m-t-sm"  style={{fontWeight:'bold', marginRight: '-20px'}}>=</span>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="value3"
                                                           onChange={this.handleChange}
                                                           name="value3"
                                                           value={this.state.paymentProcessorConfig.value3 ? this.state.paymentProcessorConfig.value3 : ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="key4"
                                                           onChange={this.handleChange}
                                                           name="key4"
                                                           value={this.state.paymentProcessorConfig.key4 ? this.state.paymentProcessorConfig.key4 : ''}
                                                    />
                                                </div>
                                                <span className="col-lg-1 m-t-sm"  style={{fontWeight:'bold', marginRight: '-20px'}}>=</span>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="value4"
                                                           onChange={this.handleChange}
                                                           name="value4"
                                                           value={this.state.paymentProcessorConfig.value4 ? this.state.paymentProcessorConfig.value4 : ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="key5"
                                                           onChange={this.handleChange}
                                                           name="key5"
                                                           value={this.state.paymentProcessorConfig.key5 ? this.state.paymentProcessorConfig.key5 : ''}
                                                    />
                                                </div>
                                                <span className="col-lg-1 m-t-sm"  style={{fontWeight:'bold', marginRight: '-20px'}}>=</span>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" id="value5"
                                                           onChange={this.handleChange}
                                                           name="value5"
                                                           value={this.state.paymentProcessorConfig.value5 ? this.state.paymentProcessorConfig.value5 : ''}
                                                    />
                                                </div>
                                            </div>
                                            </div>

                                        </div>
                                    </div>


                                <div className="form-group">
                                    <div className="col-lg-offset-4 col-lg-7" style={{marginLeft: "37.5%"}}>
                                        <Link to="/" className="btn btn-white" style = {{marginLeft: '7px'}}>{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                        <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')} disabled={this.state.disabledButton===true}/>
                                    </div>
                                </div>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PaymentProcessorConfiguration


// WEBPACK FOOTER //
// ./src/components/organization/PaymentProcessorConfiguration.js